package com.arena_web.ui.components

import androidx.compose.runtime.Composable
import com.arena_web.ui.utils.Constants
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.styleModifier
import org.jetbrains.compose.web.attributes.ATarget
import org.jetbrains.compose.web.attributes.target
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Text

/** Crawlable App Store + Google Play download links (real `<a href>`). */
@Composable
fun StoreDownloadLinks() {
    Row(modifier = Modifier.styleModifier {
        property("gap", "16px")
        property("flex-wrap", "wrap")
    }) {
        StoreDownloadLink("Download for iOS", Constants.APP_STORE_URL)
        StoreDownloadLink("Download for Android", Constants.GOOGLE_PLAY_URL)
    }
}

@Composable
private fun StoreDownloadLink(label: String, href: String) {
    A(
        href = href,
        attrs = {
            target(ATarget.Blank)
            attr("rel", "noopener noreferrer")
            style {
                property("color", "#0061FF")
                property("font-weight", "600")
                property("text-decoration", "underline")
            }
        }
    ) { Text(label) }
}
